<template>
  <div>
    <h1 class="page-header">{{ $t('holiday.holiday') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-2 col-md-2 col-sm-12">
            <ts-date-picker-input
              format="YYYY"
              v-model="dateGenerate.year"
            ></ts-date-picker-input>
            <div class="validate" v-if="errors.has('year')">
              {{ errors.first('year') }}
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12">
            <ts-button
              v-show="isStaff"
              outline
              color="info"
              :waiting="waiting"
              @click.prevent="generateHoliday"
            >
              {{ $t('holiday.generate') }}
            </ts-button>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-12">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>
            <span v-if="model.hol_id != record.hol_id">{{
              record.hol_date
            }}</span>
            <ts-date-picker-input
              v-if="model.hol_id == record.hol_id"
              readonly
              v-model="model.hol_date"
              :class="{ 'is-invalid': errors.has('hol_date') }"
            >
            </ts-date-picker-input>
          </td>
          <td class="kh-font">
            <span v-if="model.hol_id != record.hol_id">{{
              record.hol_name_kh
            }}</span>
            <input
              v-if="model.hol_id == record.hol_id"
              v-model="model.hol_name_kh"
              type="text"
              class="form-control kh-font"
              :class="{ 'is-invalid': errors.has('hol_name_kh') }"
              :placeholder="$t('holiday.holidaynameKH')"
            />
            <span
              v-if="errors.has('hol_name_kh') && model.hol_id == record.hol_id"
              :class="{ 'text-danger': errors.has('hol_name_kh') }"
            >
              {{ errors.first('hol_name_kh') }}
            </span>
          </td>
          <td>
            <span v-if="model.hol_id != record.hol_id">{{
              record.hol_name_en
            }}</span>
            <input
              v-if="model.hol_id == record.hol_id"
              v-model="model.hol_name_en"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('hol_name_en') }"
              :placeholder="$t('holiday.holidaynameEN')"
            />
            <span
              v-if="errors.has('hol_name_en') && model.hol_id == record.hol_id"
              :class="{ 'text-danger': errors.has('hol_name_en') }"
            >
              {{ errors.first('hol_name_en') }}
            </span>
          </td>
          <td>
            <span v-if="model.hol_id != record.hol_id">{{
              record.hol_desc
            }}</span>
            <textarea
              v-if="model.hol_id == record.hol_id"
              v-model="model.hol_desc"
              rows="1"
              class="form-control"
              :class="{ 'is-invalid': errors.has('hol_desc') }"
              :placeholder="$t('holiday.holidaydescription')"
              style="padding: 7px 10px;"
            ></textarea>
            <span
              v-if="errors.has('hol_desc') && model.hol_id == record.hol_id"
              :class="{ 'text-danger': errors.has('hol_desc') }"
            >
              {{ errors.first('hol_desc') }}
            </span>
          </td>
          <td class="text-center">
            <ts-button
              v-show="isStaff"
              v-if="model.hol_id == record.hol_id"
              class="btn-xs btn-primary mr-2"
              @click="update(record)"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-save" v-else></i>
            </ts-button>
            <ts-button
              v-show="isStaff"
              @click="cancel"
              v-if="model.hol_id == record.hol_id"
              class="btn-xs btn-default"
            >
              <i class="fa fa-times"></i>
            </ts-button>
            <a
              v-show="isStaff"
              v-if="model.hol_id != record.hol_id"
              href="#"
              title="edit"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'holiday',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      dateGenerate: {
        year: moment().format('YYYY')
      },
      model: {
        hol_id: '',
        hol_date: '',
        hol_name_kh: '',
        hol_name_en: '',
        hol_desc: ''
      },
      columns: [
        { name: this.$t('holiday.date'), style: 'width: 13%;' },
        { name: this.$t('holiday.holidaynameKH'), sortKey: 'hol_name_kh' },
        { name: this.$t('holiday.holidaynameEN') },
        { name: this.$t('holiday.remark') },
        {
          name: this.$t('holiday.actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('holiday', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.holiday.search
      },
      set(newValue) {
        this.$store.commit('holiday/SET_SEARCH', newValue)
        this.$store.commit('holiday/RESET_CURRENT_PAGE')
      }
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('holiday/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async generateHoliday() {
      if (this.resources.length > 0) {
        if (
          await this.$confirmModal.danger(
            ' Are you sure to generate new ? Old data will be lost.'
          )
        ) {
          this.generate()
        }
      } else {
        this.generate()
      }
    },
    generate() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('holiday/store', this.dateGenerate)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
          this.waiting = false
        })
        .catch(error => {
          this.waiting = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    edit(record) {
      this.errors = new Errors()
      this.model.hol_id = record.hol_id
      this.model.hol_date = record.hol_date
      this.model.hol_name_kh = record.hol_name_kh
      this.model.hol_name_en = record.hol_name_en
      this.model.hol_desc = record.hol_desc
    },
    update(record) {
      record._deleting = true
      this.$store
        .dispatch('holiday/update', Object.assign({}, this.model))
        .then(response => {
          record._deleting = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          record._deleting = false
        })
    },
    cancel() {
      this.model.hol_id = ''
      this.model.hol_id = ''
      this.model.hol_date = ''
      this.model.hol_name_kh = ''
      this.model.hol_name_en = ''
      this.model.hol_desc = ''
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('holiday/RESET_STATE')
    }
    next()
  }
}
</script>

<style lang="css" scoped>
table td {
	vertical-align : middle;
}
</style>
